import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import BaseUrl from '../../ApiServices/BaseUrl';
import { Button, Dropdown, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {
  FaUser, FaBuilding, FaPhoneAlt, FaEye, FaRegHeart, FaShareAlt,
  FaEnvelope, FaIdCard, FaCheckCircle, FaUserCircle, FaLaptop,
  FaBriefcase, FaWhatsapp, FaTelegramPlane, FaMailBulk, FaBold,
  FaHome, FaCalendarAlt, FaExchangeAlt, FaMapMarkerAlt, FaFileAlt,
  FaPassport, FaMoneyBillAlt, FaInfoCircle, FaUtensils, FaStar,
  FaLanguage, FaCogs, FaUserFriends, FaGraduationCap
} from 'react-icons/fa';
import { FaCar, FaUserNurse, FaStethoscope, FaUserTie, FaRunning, FaTools } from 'react-icons/fa';
import Swal from 'sweetalert2';
import AgencyNavbar from '../../Pages/Navbar/AgencyNavbar';

import './CandidatesViewadmin.css';

const CandidatesViewadmin = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showReportForm, setShowReportForm] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [hasPostedJob, setHasPostedJob] = useState(false);
  const [checkingJobPost, setCheckingJobPost] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState('Pending');
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [offerValue, setOfferValue] = useState('');
  const [updatingOffer, setUpdatingOffer] = useState(false);
  const [showVerifiedBadge, setShowVerifiedBadge] = useState(false);
  const [updatingVerifiedBadge, setUpdatingVerifiedBadge] = useState(false);
  const [showActiveTag, setShowActiveTag] = useState(false);
  const [updatingActiveTag, setUpdatingActiveTag] = useState(false);
  const [customSourceLabel, setCustomSourceLabel] = useState('');
  const [updatingCustomSourceLabel, setUpdatingCustomSourceLabel] = useState(false);
  const { userId } = useParams();
  const navigate = useNavigate();

  console.log("Received userId:", userId); // Debugging

  // Helper function to safely parse array fields
  const safeParseJSON = (jsonString) => {
    if (!jsonString) return [];
    try {
      // Handle cases where the string might already be parsed
      if (typeof jsonString === 'object') return jsonString;
      // Handle cases where the string has escaped quotes
      const cleanedString = jsonString.replace(/\"/g, '"');
      return JSON.parse(cleanedString);
    } catch (e) {
      // If parsing fails, try to handle as a string array
      if (Array.isArray(jsonString)) return jsonString;
      if (typeof jsonString === 'string') return [jsonString];
      return [];
    }
  };

  // Helper function to determine job position
  const getJobPosition = () => {
    if (!profileData?.job_position) return '';

    const positions = safeParseJSON(profileData.job_position);

    if (Array.isArray(positions) && positions.length > 0) {
      return positions[0].toLowerCase();
    }
    return '';
  };

  // Check specific job types
  const isCook = () => jobPosition.includes('cook');
  const isTeacher = () => jobPosition.includes('teacher') || jobPosition.includes('tutor');
  const isNurse = () => jobPosition.toLowerCase().includes('nurse');
  const isDoctor = () => jobPosition.includes('doctor') || jobPosition.includes('physician');
  const isDriver = () => jobPosition.includes('driver');
  const isTailor = () => jobPosition.includes('tailor');
  const isTrainer = () => jobPosition.includes('trainer') || jobPosition.includes('coach');
  const isBeautician = () => jobPosition.includes('beautician');
  const isDomesticHelper = () => jobPosition.includes('domestic') || jobPosition.includes('helper') || jobPosition.includes('maid');

  const jobPosition = getJobPosition();

  // Specialized fields parsing
  const drivingLicenseCountries = safeParseJSON(profileData?.driving_license_countries);
  const carTypesDriven = safeParseJSON(profileData?.car_types_driven);
  const previousCarsDriven = safeParseJSON(profileData?.previous_cars_driven);
  const nursingQualifications = safeParseJSON(profileData?.nursing_qualifications);
  const nursingPositions = safeParseJSON(profileData?.nursing_positions);
  const nursingJobCountries = safeParseJSON(profileData?.nursing_job_countries);
  const nursingLicenseCountries = safeParseJSON(profileData?.nursing_license_countries);
  const teachingSubjects = safeParseJSON(profileData?.subjects);
  const teachingAgeGroups = safeParseJSON(profileData?.age_groups);
  const teachingClasses = safeParseJSON(profileData?.classes);
  const beauticianServices = {
    henna: safeParseJSON(profileData?.henna_services),
    makeup: safeParseJSON(profileData?.makeup_services),
    skinCare: safeParseJSON(profileData?.skin_care_services),
    nail: safeParseJSON(profileData?.nail_services),
    hair: safeParseJSON(profileData?.hair_services),
    massage: safeParseJSON(profileData?.massage_spa_services)
  };
  const tailorSkills = {
    mode: profileData?.tailor_mode,
    type: profileData?.tailor_type,
    stitching: safeParseJSON(profileData?.stitching_preferences),
    fabric: safeParseJSON(profileData?.fabric_preference),
    style: safeParseJSON(profileData?.style_preference)
  };
  const trainingDetails = {
    mode: profileData?.training_mode,
    sports: safeParseJSON(profileData?.sports_games),
    ageGroups: safeParseJSON(profileData?.sports_age_groups)
  };

  useEffect(() => {
    // Get current user from localStorage
    const user = JSON.parse(localStorage.getItem('user')) || null;
    setCurrentUser(user);

    const fetchProfileData = async () => {
      try {
        console.log("Fetching data for userId:", userId);
        const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`);
        console.log("Raw response:", response);

        if (!response.ok) {
          throw new Error('Failed to fetch profile data');
        }

        const data = await response.json();
        console.log("Fetched profile data:", data);

        // Construct full URL for the profile photo if it exists
        if (data.profile_photo) {
          data.profile_photo = `${BaseUrl}${data.profile_photo}`;
          console.log("Updated profile photo URL:", data.profile_photo);
        }

        // Set verification status from the data
        if (data.verification_status) {
          setVerificationStatus(data.verification_status);
        }

        setOfferValue(data.badge_text || data.offer || '');
        setShowVerifiedBadge(Number(data.purchased_badge) === 1);
        setShowActiveTag(Number(data.admin_active_tag) === 1);
        setCustomSourceLabel(data.admin_custom_source_label || '');

        setProfileData(data);
      } catch (err) {
        console.error("Error fetching profile data:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchProfileData();
    }
  }, [userId]);

  // Check if current user has posted any jobs
  const checkIfUserHasPostedJob = async () => {
    if (!currentUser) return false;

    setCheckingJobPost(true);
    try {
      const response = await fetch(`${BaseUrl}/api/employer/all`);
      if (!response.ok) {
        throw new Error('Failed to fetch employer data');
      }
      const data = await response.json();
      const userHasPostedJob = data.some(job => job.user_id === currentUser.id);
      setHasPostedJob(userHasPostedJob);
      return userHasPostedJob;
    } catch (err) {
      console.error("Error checking job posts:", err);
      return false;
    } finally {
      setCheckingJobPost(false);
    }
  };

  // Handle verification status change
  const handleVerificationStatusChange = async (status) => {
    setUpdatingStatus(true);
    try {
      const response = await fetch(`${BaseUrl}/api/job-seeker/status/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          verification_status: status
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update verification status');
      }

      const updatedData = await response.json();
      setVerificationStatus(status);

      Swal.fire({
        title: 'Success',
        text: `Candidate status updated to ${status}`,
        icon: 'success',
        confirmButtonText: 'OK'
      });
    } catch (err) {
      console.error("Error updating verification status:", err);
      Swal.fire({
        title: 'Error',
        text: 'Failed to update verification status',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setUpdatingStatus(false);
    }
  };

  // Handle offer value change
  const handleOfferChange = (e) => {
    const value = e.target.value;

    // Check if input exceeds 20 characters
    if (value.length > 20) {
      Swal.fire({
        title: 'Warning',
        text: 'Badge text cannot exceed 20 characters',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    setOfferValue(value);
  };

  // Save offer value to database
  const saveOfferValue = async () => {
    // Additional check before saving
    if (offerValue.length > 20) {
      Swal.fire({
        title: 'Warning',
        text: 'Badge text cannot exceed 20 characters',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    if (!offerValue.trim()) {
      Swal.fire({
        title: 'Warning',
        text: 'Badge text cannot be empty',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    // Rest of the saveOfferValue function remains the same...
    setUpdatingOffer(true);
    try {
      const response = await fetch(`${BaseUrl}/api/admin/job-seeker/assign-badge`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          candidate_id: userId,
          badge_text: offerValue
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update badge');
      }

      const updatedData = await response.json();

      Swal.fire({
        title: 'Success',
        text: 'Badge updated successfully',
        icon: 'success',
        confirmButtonText: 'OK'
      });

      setProfileData((prev) => prev ? {
        ...prev,
        badge_text: offerValue,
        badge_status: 'assigned'
      } : prev);
    } catch (err) {
      console.error("Error updating offer:", err);
      Swal.fire({
        title: 'Error',
        text: 'Failed to update badge',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setUpdatingOffer(false);
    }
  };

  const handleVerifiedBadgeToggle = async (e) => {
    const nextValue = e.target.checked;
    setShowVerifiedBadge(nextValue);
    setUpdatingVerifiedBadge(true);

    try {
      const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          purchased_badge: nextValue ? 1 : 0
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update verified badge setting');
      }

      setProfileData((prev) => prev ? {
        ...prev,
        purchased_badge: nextValue ? 1 : 0
      } : prev);

      Swal.fire({
        title: 'Success',
        text: `Verified tag ${nextValue ? 'enabled' : 'disabled'} successfully`,
        icon: 'success',
        confirmButtonText: 'OK'
      });
    } catch (err) {
      console.error("Error updating verified badge setting:", err);
      setShowVerifiedBadge(!nextValue);
      Swal.fire({
        title: 'Error',
        text: 'Failed to update verified tag setting',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setUpdatingVerifiedBadge(false);
    }
  };

  const handleActiveTagToggle = async (e) => {
    const nextValue = e.target.checked;
    setShowActiveTag(nextValue);
    setUpdatingActiveTag(true);

    try {
      const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          admin_active_tag: nextValue ? 1 : 0
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update active tag setting');
      }

      setProfileData((prev) => prev ? {
        ...prev,
        admin_active_tag: nextValue ? 1 : 0
      } : prev);

      Swal.fire({
        title: 'Success',
        text: `Very Active tag ${nextValue ? 'enabled' : 'disabled'} successfully`,
        icon: 'success',
        confirmButtonText: 'OK'
      });
    } catch (err) {
      console.error("Error updating active tag setting:", err);
      setShowActiveTag(!nextValue);
      Swal.fire({
        title: 'Error',
        text: 'Failed to update Very Active tag setting',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setUpdatingActiveTag(false);
    }
  };

  const handleCustomSourceLabelChange = (e) => {
    const value = e.target.value;

    if (value.length > 25) {
      Swal.fire({
        title: 'Warning',
        text: 'Custom label cannot exceed 25 characters',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    setCustomSourceLabel(value);
  };

  const saveCustomSourceLabel = async () => {
    const trimmedValue = customSourceLabel.trim();

    if (!trimmedValue) {
      Swal.fire({
        title: 'Warning',
        text: 'Custom label cannot be empty',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    setUpdatingCustomSourceLabel(true);
    try {
      const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          admin_custom_source_label: trimmedValue
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update custom source label');
      }

      setCustomSourceLabel(trimmedValue);
      setProfileData((prev) => prev ? {
        ...prev,
        admin_custom_source_label: trimmedValue
      } : prev);

      Swal.fire({
        title: 'Success',
        text: 'Custom label saved successfully',
        icon: 'success',
        confirmButtonText: 'OK'
      });
    } catch (err) {
      console.error("Error updating custom source label:", err);
      Swal.fire({
        title: 'Error',
        text: 'Failed to update custom label',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setUpdatingCustomSourceLabel(false);
    }
  };

  const clearCustomSourceLabel = async () => {
    setUpdatingCustomSourceLabel(true);
    try {
      const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          admin_custom_source_label: null
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to clear custom source label');
      }

      setCustomSourceLabel('');
      setProfileData((prev) => prev ? {
        ...prev,
        admin_custom_source_label: null
      } : prev);

      Swal.fire({
        title: 'Success',
        text: 'Custom label cleared successfully',
        icon: 'success',
        confirmButtonText: 'OK'
      });
    } catch (err) {
      console.error("Error clearing custom source label:", err);
      Swal.fire({
        title: 'Error',
        text: 'Failed to clear custom label',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setUpdatingCustomSourceLabel(false);
    }
  };

  // Handle contact button click
  // Handle contact button click in Admin component
  const handleContactClick = async () => {
    if (!currentUser) {
      await Swal.fire({
        title: 'Login Required',
        text: 'Please login to contact candidates',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      navigate('/basicinfo');
      return;
    }

    // For Admin, check if user has posted a job (same as employer)
    const userHasJob = await checkIfUserHasPostedJob();
    // if (!userHasJob) {
    //     await Swal.fire({
    //         title: 'Post a Job First',
    //         text: 'Please post a job before you can access candidate contact information',
    //         icon: 'warning',
    //         confirmButtonText: 'OK'
    //     });
    //     navigate('/basicinfo');
    //     return;
    // }

    // Get candidate's phone number
    const candidatePhone = profileData.whatsapp_number || profileData.phone_number || '9820867896';

    // Clean the phone number
    const cleanNumber = candidatePhone.replace(/\D/g, '');

    // Format number for tel: link
    let finalNumber = cleanNumber;
    if (!cleanNumber.startsWith('+')) {
      if (cleanNumber.startsWith('91') && cleanNumber.length === 12) {
        finalNumber = '+' + cleanNumber;
      } else if (cleanNumber.length === 10) {
        finalNumber = '+91' + cleanNumber;
      } else {
        finalNumber = '+919820867896'; // Default number
      }
    }

    // Directly open the native call dialog
    window.location.href = `tel:${finalNumber}`;
  };

  // Render Cook specific fields
  const renderCookSpecificFields = () => (
    <>
      {/* Cooking Skills */}
      <div className="mb-3 desktop-section candidate-view-desktop-center">
        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
          <FaUtensils size={20} className="me-2" />
          <span className="ms-2">Cooking Skills</span>
        </h6>
        <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
          {cookingSkills.map((item, index) => (
            <span key={index} className="skill-tag">{item}</span>
          ))}
        </div>
      </div>

      {/* Other Skills */}
      <div className="mb-3 desktop-section candidate-view-desktop-center">
        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
          <FaStar size={20} className="me-2" />
          <span className="ms-2">Other Skills</span>
        </h6>
        <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
          {otherSkills.map((item, index) => (
            <span key={index} className="skill-tag">{item}</span>
          ))}
        </div>
      </div>
    </>
  );

  // Render Teacher specific fields
  const renderTeacherSpecificFields = () => (
    <>
      {/* Teaching Subjects */}
      <div className="mb-3 desktop-section candidate-view-desktop-center">
        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
          <FaGraduationCap size={20} className="me-2" />
          <span className="ms-2">Teaching Subjects</span>
        </h6>
        <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
          {teachingSubjects.map((subject, index) => (
            <span key={index} className="skill-tag">{subject}</span>
          ))}
        </div>
      </div>

      {/* Teaching Levels */}
      <div className="mb-3 desktop-section candidate-view-desktop-center">
        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
          <FaUser size={20} className="me-2" />
          <span className="ms-2">Teaching Levels</span>
        </h6>
        <div className="d-flex flex-wrap gap-3 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
          {teachingAgeGroups.length > 0 && (
            <div>
              <strong>Age Groups:</strong>
              <div className="d-flex flex-wrap gap-2 mt-1">
                {teachingAgeGroups.map((age, index) => (
                  <span key={index} className="skill-tag">{age}</span>
                ))}
              </div>
            </div>
          )}
          {teachingClasses.length > 0 && (
            <div>
              <strong>Classes:</strong>
              <div className="d-flex flex-wrap gap-2 mt-1">
                {teachingClasses.map((cls, index) => (
                  <span key={index} className="skill-tag">{cls}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );

  // Replace the entire renderNurseSpecificFields() function with this:

  const renderNurseSpecificFields = () => (
    <>
      {/* Nursing Qualifications */}
      <div className="mb-3 desktop-section candidate-view-desktop-center">
        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
          <FaStethoscope size={20} className="me-2" />
          <span className="ms-2">Nursing Qualifications</span>
        </h6>
        <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
          {nursingQualifications.map((qual, index) => (
            <span key={index} className="skill-tag">{qual}</span>
          ))}
        </div>
      </div>

      {/* Nursing Positions */}
      <div className="mb-3 desktop-section candidate-view-desktop-center">
        <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
          <FaUserNurse size={20} className="me-2" />
          <span className="ms-2">Nursing Positions</span>
        </h6>
        <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
          {nursingPositions.map((position, index) => (
            <span key={index} className="skill-tag">{position}</span>
          ))}
        </div>
      </div>

      {/* Nursing Experience Countries */}
      {nursingJobCountries.length > 0 && (
        <div className="mb-3 desktop-section candidate-view-desktop-center">
          <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
            <FaMapMarkerAlt size={20} className="me-2" />
            <span className="ms-2">Countries Worked as Nurse</span>
          </h6>
          <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
            {nursingJobCountries.map((country, index) => (
              <span key={index} className="skill-tag">{country}</span>
            ))}
          </div>
        </div>
      )}

      {/* Prometric Certificate Details */}
      {(profileData.has_prometric_certificate === 1 || profileData.has_prometric_certificate === true) && (
        <div className="mb-3 desktop-section candidate-view-desktop-center">
          <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
            <FaCheckCircle size={20} className="me-2" />
            <span className="ms-2">Prometric Certificate</span>
          </h6>
          <div className="d-flex flex-wrap gap-3 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
            <div className="bg-light p-3 rounded">
              <ul className="mb-0 ps-3">
                {profileData.prometric_issued_country && (
                  <li><strong>Issued Country:</strong> {profileData.prometric_issued_country}</li>
                )}
                {profileData.prometric_issue_date && (
                  <li><strong>Issue Date:</strong> {new Date(profileData.prometric_issue_date).toLocaleDateString()}</li>
                )}
                {profileData.prometric_expiry_date && (
                  <li><strong>Expiry Date:</strong> {new Date(profileData.prometric_expiry_date).toLocaleDateString()}</li>
                )}
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Dataflow Certificate Details */}
      {(profileData.has_dataflow_certificate === 1 || profileData.has_dataflow_certificate === true) && (
        <div className="mb-3 desktop-section candidate-view-desktop-center">
          <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
            <FaCheckCircle size={20} className="me-2" />
            <span className="ms-2">Dataflow Certificate</span>
          </h6>
          <div className="d-flex flex-wrap gap-3 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
            <div className="bg-light p-3 rounded">
              <ul className="mb-0 ps-3">
                {profileData.dataflow_issued_country && (
                  <li><strong>Issued Country:</strong> {profileData.dataflow_issued_country}</li>
                )}
                {profileData.dataflow_issue_date && (
                  <li><strong>Issue Date:</strong> {new Date(profileData.dataflow_issue_date).toLocaleDateString()}</li>
                )}
                {profileData.dataflow_expiry_date && (
                  <li><strong>Expiry Date:</strong> {new Date(profileData.dataflow_expiry_date).toLocaleDateString()}</li>
                )}
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Nursing License Countries */}
      {nursingLicenseCountries.length > 0 && (
        <div className="mb-3 desktop-section candidate-view-desktop-center">
          <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
            <FaIdCard size={20} className="me-2" />
            <span className="ms-2">Nursing License Countries</span>
          </h6>
          <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
            {nursingLicenseCountries.map((license, index) => (
              <span key={index} className="skill-tag">{license}</span>
            ))}
          </div>
        </div>
      )}
    </>
  );

  // Render Driver specific fields
  const renderDriverSpecificFields = () => {
    const countries = drivingLicenseCountries || [];
    const filtered = countries.filter(c => c && c !== "I don't have driving license" && c !== "I Don't have License" && c !== "Not Licensed");

    return (
      <>
        {/* Driving License */}
        <div className="mb-3 desktop-section candidate-view-desktop-center">
          <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
            <FaCar size={20} className="me-2" />
            <span className="ms-2">Driving License</span>
          </h6>
          <div className="d-flex flex-wrap gap-3 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
            <div>
              <strong>Countries:</strong>
              <div className="d-flex flex-wrap gap-2 mt-1">
                {filtered.length > 0 ? filtered.map((country, index) => (
                  <span key={index} className="skill-tag">{country}</span>
                )) : (
                  <span className="skill-tag">Not Licensed</span>
                )}
              </div>
            </div>
            {carTypesDriven.length > 0 && (
              <div>
                <strong>Car Types:</strong>
                <div className="d-flex flex-wrap gap-2 mt-1">
                  {carTypesDriven.map((type, index) => (
                    <span key={index} className="skill-tag">{type}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const formatSalary = (salary) => {
    if (!salary) return '';

    // Convert to number if it's a string
    const salaryNum = typeof salary === 'string' ? parseFloat(salary) : salary;

    if (isNaN(salaryNum)) return salary;

    // Apply floor/ceil logic
    const roundedSalary = salaryNum % 1 >= 0.50 ? Math.ceil(salaryNum) : Math.floor(salaryNum);

    // Remove double zero by converting to integer if it's a whole number
    return roundedSalary % 1 === 0 ? roundedSalary.toString() : roundedSalary.toFixed(2);
  };

  // Parse all JSON fields safely
  const jobPositions = safeParseJSON(profileData?.job_position);
  const languages = safeParseJSON(profileData?.language);
  const mainSkills = safeParseJSON(profileData?.main_skills);
  const cookingSkills = safeParseJSON(profileData?.cooking_skills);
  const otherSkills = safeParseJSON(profileData?.other_skills);
  const personality = safeParseJSON(profileData?.personality);
  const experience = safeParseJSON(profileData?.experience);
  const preferredLocations = safeParseJSON(profileData?.preffered_job_locations);
  const education = safeParseJSON(profileData?.education);

  const toggleReportForm = () => {
    setShowReportForm(!showReportForm);
  };

  if (loading) {
    return (
      <>
        <AdminNavbar />
        <div className="text-center mt-5" style={{ marginTop: '50px' }}>Loading profile data...</div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <AdminNavbar />
        <div className="text-center mt-5 text-danger">Error: {error}</div>
      </>
    );
  }

  if (!profileData) {
    return (
      <>
        <AdminNavbar />
        <div className="text-center mt-5">No profile data found</div>
      </>
    );
  }

  const handleBack = () => {
    navigate('/manageemployee');
  };

  return (
    <>
      <AdminNavbar />
      <div className="combined-profile-details-container p-3" style={{ marginTop: '55px' }}>
        <div style={{ textAlign: 'center', marginBottom: '10px', marginTop: '15px' }}>
          <Button variant="outline-secondary"
            onClick={handleBack}>
            ← Back to Candidates List
          </Button>
        </div>
        <div className="combined-profile-details-card bg-white shadow rounded-4">
          {/* Divider */}
          <hr className="profile-divider" />
          {/* Second Profile Section */}
          <div className="profile-section p-3">
            {/* Top Tags */}
            <div className='bg-light'>
              <div className="d-flex justify-content-between px-2 mb-2">
                <span></span>
                <div className="d-flex align-items-center gap-2">
                  {/* <Button
                    variant="success" className='profile-badge-green-admin'
                    size="sm"
                    onClick={handleContactClick}
                    disabled={checkingJobPost}
                  >
                    {checkingJobPost ? 'Checking...' : 'Contact'}
                  </Button> */}
                  <Dropdown>
                    <Dropdown.Toggle
                      variant={verificationStatus === 'Verified' ? 'success' :
                        verificationStatus === 'Not Verified' ? 'danger' : 'warning'}
                      size="sm"
                      disabled={updatingStatus} className='profile-badge-green-admin'
                    >
                      {updatingStatus ? 'Updating...' : verificationStatus}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => handleVerificationStatusChange('Verified')}
                        active={verificationStatus === 'Verified'} className='profile-badge-green-admin'
                      >
                        Verify
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => handleVerificationStatusChange('Not Verified')}
                        active={verificationStatus === 'Not Verified'} className='profile-badge-green-admin'
                      >
                        Not Verify
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <span></span>
              </div>
              {/* Profile Image */}
              <div className="profile-img-wrapper position-relative mx-auto mb-3">
                {profileData.profile_photo ? (
                  <img
                    src={profileData.profile_photo}
                    alt="Profile"
                    className="profile-img rounded-circle"
                  />
                ) : (
                  <div className="rounded-circle d-flex align-items-center justify-content-center bg-light">
                    <i className="bi bi-person-fill text-muted" style={{ fontSize: '3rem' }}></i>
                  </div>
                )}
              </div>
              {/* Bottom Tags */}
              <div className="d-flex justify-content-between px-3 mb-2">
                <span className="profile-label-green">Gulf Exp.</span>
                <span className="profile-label-green">{profileData.accommodation_preference}</span>
              </div>
            </div>
            {/* Info Section */}
            <div className="profile-info bg-light p-3 rounded-3">
              <h5 className="fw-bold mb-2">
                • Name- {profileData.first_name.split('@')[0]}, {profileData.age} Years Old
              </h5>
              <p className="mb-0 fw-bold">
                Job Position - <span className="fw-bold">{jobPositions.join(', ')}</span>
              </p>

              {/* Add this section right after the job position line */}
              {isNurse() && (
                <div className="nurse-top-certifications mt-1">
                  {(profileData.has_prometric_certificate === 1 || profileData.has_prometric_certificate === true) && (
                    <span className="badge bg-success me-2 mb-1">
                      <FaCheckCircle className="me-1" /> Prometric Certified
                    </span>
                  )}
                  {(profileData.has_dataflow_certificate === 1 || profileData.has_dataflow_certificate === true) && (
                    <span className="badge bg-info me-2 mb-1">
                      <FaCheckCircle className="me-1" /> Dataflow Verified
                    </span>
                  )}
                  {nursingLicenseCountries.length > 0 && (
                    <span className="badge bg-warning text-dark mb-1">
                      <FaIdCard className="me-1" /> Licensed Nurse
                    </span>
                  )}
                </div>
              )}


              <p className="mb-0">Total Experience - {profileData.total_work_experience === 'Fresher (0 Year)' || profileData.total_work_experience === '0' || profileData.total_work_experience === 0 ? 'Fresher' : profileData.total_work_experience}</p>
              <p className="mb-1">Current Location - {profileData.current_country}</p>

            </div>
          </div>

          {/* Offer Field - Only show when candidate is verified */}
          {verificationStatus === 'Verified' && (
            <>
              <hr className="profile-divider" />
              <div className="offer-section p-3">
                <h6 className="fw-bold text-primary d-flex align-items-center">
                  ✅ <span className="ms-2">Offer</span>
                </h6>
                <div className="offer-admin mt-2">
                  <Form.Control
                    type="text"
                    value={offerValue}
                    onChange={handleOfferChange}
                    placeholder="Enter badge text"
                    className="offer-input"
                  />
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={saveOfferValue}
                    disabled={updatingOffer}
                    className="offer-save-btn"
                  >
                    {updatingOffer ? 'Saving...' : 'Save Badge'}
                  </Button>
                </div>
                <div className="verified-toggle-admin mt-3">
                  <div className="verified-toggle-admin__text">
                    <div className="verified-toggle-admin__title">Verified tag on card</div>
                    <div className="verified-toggle-admin__desc">
                      Turn this on to show the "Verified" tag on this candidate card.
                    </div>
                  </div>
                  <Form.Check
                    type="switch"
                    id="show-verified-badge-switch"
                    label=""
                    checked={showVerifiedBadge}
                    disabled={updatingVerifiedBadge}
                    onChange={handleVerifiedBadgeToggle}
                    className="verified-toggle-admin__switch"
                  />
                </div>
                {updatingVerifiedBadge && (
                  <div className="verified-toggle-admin__saving">Saving verified tag setting...</div>
                )}
                <div className="verified-toggle-admin mt-3">
                  <div className="verified-toggle-admin__text">
                    <div className="verified-toggle-admin__title">Very Active tag in place of Direct</div>
                    <div className="verified-toggle-admin__desc">
                      Turn this on to show "Very Active" instead of the default source label on this candidate card.
                    </div>
                  </div>
                  <Form.Check
                    type="switch"
                    id="show-active-tag-switch"
                    label=""
                    checked={showActiveTag}
                    disabled={updatingActiveTag}
                    onChange={handleActiveTagToggle}
                    className="verified-toggle-admin__switch"
                  />
                </div>
                {updatingActiveTag && (
                  <div className="verified-toggle-admin__saving">Saving Very Active tag setting...</div>
                )}
                <div className="verified-toggle-admin mt-3">
                  <div className="verified-toggle-admin__text">
                    <div className="verified-toggle-admin__title">Custom label in place of Direct</div>
                    <div className="verified-toggle-admin__desc">
                      Save a custom label to override both "Direct" and "Very Active" on this candidate card.
                    </div>
                  </div>
                </div>
                <div className="offer-admin mt-2">
                  <Form.Control
                    type="text"
                    value={customSourceLabel}
                    onChange={handleCustomSourceLabelChange}
                    placeholder="Enter custom label"
                    className="offer-input"
                    disabled={updatingCustomSourceLabel}
                  />
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={saveCustomSourceLabel}
                    disabled={updatingCustomSourceLabel}
                    className="offer-save-btn"
                  >
                    {updatingCustomSourceLabel ? 'Saving...' : 'Save Label'}
                  </Button>
                </div>
                {(profileData?.admin_custom_source_label || customSourceLabel) && (
                  <div className="mt-2 d-flex justify-content-end">
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={clearCustomSourceLabel}
                      disabled={updatingCustomSourceLabel}
                    >
                      Clear Label
                    </Button>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Divider */}
          <hr className="profile-divider" />
          {/* Cook Details Section */}
          <div className="cook-details-section p-3">
            {/* Section: Cook Info */}
            <div className=" desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaUser size={20} className="me-2" />
                <span className="ms-2">Personal Information</span>
              </h6>
              <div className="cook-info-box candidate-view-content-wrapper-emp candidate-view-skill-info">
                <ul className="list-group list-group-flush candidate-view-skill-info">
                  <li className="list-group-item cook-info-item">
                    <span className="text-success">•</span> Gender - {profileData.gender}
                  </li>
                  <li className="list-group-item cook-info-item">
                    <span className="text-success">•</span> Religion - {profileData.religion}
                  </li>
                  <li className="list-group-item cook-info-item">
                    <span className="text-success">•</span> Marital Status - {profileData.marital_status}
                  </li>
                  <li className="list-group-item cook-info-item">
                    <span className="text-success">•</span> Nationality - {profileData.nationality}
                  </li>
                  <li className="list-group-item cook-info-item">
                    <span className="text-success">•</span> Qualification - {education[0]?.level || 'Not specified'}
                  </li>
                  <li className="list-group-item cook-info-item">
                    <span className="text-success">•</span> Language - {languages.map(lang => lang.language).join(', ')}
                  </li>
                  <li className="list-group-item cook-info-item">
                    <span className="text-success">•</span> Experience - {profileData.total_work_experience === 'Fresher (0 Year)' || profileData.total_work_experience === '0' || profileData.total_work_experience === 0 ? 'Fresher' : profileData.total_work_experience}
                  </li>
                </ul>
              </div>
            </div>
            {/* Language Sections */}
            {languages.map((lang, idx) => (
              <div className="mb-3 desktop-section candidate-view-desktop-center" key={idx}>
                <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                  <FaLanguage size={20} className="me-2" />
                  <span className="ms-2">{lang.language} Language</span>
                </h6>
                <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                  {lang.speaking_level && <span className="language-tag">Speak: {lang.speaking_level}</span>}
                  {lang.can_read && <span className="language-tag">Read</span>}
                  {lang.can_write && <span className="language-tag">Write</span>}
                </div>
              </div>
            ))}
            {/* Section: Main Skills */}
            <div className="mb-3 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaCogs size={20} className="me-2" />
                <span className="ms-2">Main Skills</span>
              </h6>
              <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                {mainSkills.map((skill, idx) => (
                  <span key={idx} className="skill-tag">{skill}</span>
                ))}
              </div>
            </div>

            {/* Job Position Specific Fields */}
            {isCook() && renderCookSpecificFields()}
            {isTeacher() && renderTeacherSpecificFields()}
            {isNurse() && renderNurseSpecificFields()}
            {isDriver() && renderDriverSpecificFields()}

            {/* Personality */}
            <div className="mb-3 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaUserFriends size={20} className="me-2" />
                <span className="ms-2">Personality</span>
              </h6>
              <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                {personality.map((trait, index) => (
                  <span key={index} className="skill-tag">{trait}</span>
                ))}
              </div>
            </div>
            {/* Work Experience */}
            <div className="mb-3 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaBriefcase size={20} className="me-2" />
                <span className="ms-2">Work Experience</span>
              </h6>

              <div className="candidate-view-content-wrapper-emp employer-candidate-viewdetails-workexperience">
                {experience.length > 0 ? (
                  experience.map((exp, expIdx) => {
                    const countryDisplay = Array.isArray(exp.country)
                      ? exp.country.join(', ')
                      : exp.country || '';
                    const jobPositionDisplay = Array.isArray(exp.job_position)
                      ? exp.job_position.join(', ')
                      : exp.job_position || '';
                    const dutiesDisplay = Array.isArray(exp.house_duties)
                      ? exp.house_duties.join(', ')
                      : exp.house_duties;

                    return (
                      <div className="bg-light p-3 rounded candidate-view-experience-item" key={expIdx}>
                        <ul className="mb-2 ps-3">
                          <li>{exp.join_month} {exp.join_year} - {exp.exit_month} {exp.exit_year}</li>
                          <li>{jobPositionDisplay} {countryDisplay}</li>
                          <li>{exp.employer_nationality} Family</li>
                          <li>Duties - {dutiesDisplay}</li>
                        </ul>
                      </div>
                    );
                  })
                ) : (
                  <div className="bg-light p-3 rounded mt-3 candidate-view-experience-item">
                    <p>No work experience listed</p>
                  </div>
                )}
              </div>
            </div>

            <div className="mb-4 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaHome size={20} className="me-2" />
                <span className="ms-2">Accommodation</span>
              </h6>

              <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                {(Array.isArray(profileData.accommodation_preference)
                  ? profileData.accommodation_preference
                  : profileData.accommodation_preference
                    ?.split(',')
                    .filter(Boolean)
                )?.map((item, index) => (
                  <span key={index} className="skill-tag">
                    {item.trim()}
                  </span>
                ))}
              </div>
            </div>
            <div className="mb-4 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaCalendarAlt size={20} className="me-2" />
                <span className="ms-2">Day Off</span>
              </h6>

              <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                {(Array.isArray(profileData.day_off_preference)
                  ? profileData.day_off_preference
                  : profileData.day_off_preference
                    ?.split(',')
                    .filter(Boolean)
                )?.map((item, index) => (
                  <span key={index} className="skill-tag">
                    {item.trim()}
                  </span>
                ))}
              </div>
            </div>
            <div className="mb-4 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaExchangeAlt size={20} className="me-2" />
                <span className="ms-2">Reason to change the Job</span>
              </h6>

              <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                {(Array.isArray(profileData.current_work_status)
                  ? profileData.current_work_status
                  : profileData.current_work_status
                    ?.split(',')
                    .filter(Boolean)
                )?.map((item, index) => (
                  <span key={index} className="skill-tag">
                    {item.trim()}
                  </span>
                ))}
              </div>
            </div>
            <div className="mb-4 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaMapMarkerAlt size={20} className="me-2" />
                <span className="ms-2">Prefer Location</span>
              </h6>

              <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                {(Array.isArray(preferredLocations)
                  ? preferredLocations
                  : preferredLocations?.split(',').filter(Boolean)
                )?.map((loc, index) => (
                  <span key={index} className="skill-tag">
                    {loc.trim()}
                  </span>
                ))}

                {profileData.other_job_location && (
                  <span className="skill-tag">
                    {profileData.other_job_location}
                  </span>
                )}
              </div>
            </div>
            <div className="mb-4 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaFileAlt size={20} className="me-2" />
                <span className="ms-2">NOC letter / Transfer letter</span>
              </h6>

              <div className="d-flex flex-wrap gap-2 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                <span className="skill-tag">
                  {profileData.noc_or_transfer_letter ? 'Yes, I have' : 'No'}
                </span>
              </div>
            </div>

            <div className="mb-4 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaMoneyBillAlt size={20} className="me-2" />
                <span className="ms-2">My Salary Expectation</span>
              </h6>

              <div className="d-flex flex-wrap gap-3 mt-3 candidate-view-content-wrapper-emp candidate-view-tags-container employer-candidate-viewdetails">
                <span className="skill-tag">
                  Qatar – {formatSalary(profileData.expected_monthly_salary_qar)} QR
                </span>

                <span className="skill-tag">
                  USD – ${formatSalary(profileData.expected_monthly_salary_usd)}
                </span>
              </div>
            </div>

            {/* Visa Status */}
            <div className="mb-3 desktop-section candidate-view-desktop-center">
              <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                <FaPassport size={20} className="me-2" />
                <span className="ms-2">Visa Status</span>
              </h6>
              <div className="candidate-view-content-wrapper-agency">
                <div className="badge-pill-container candidate-view-badge-container">{profileData.visa_type}</div>
              </div>
            </div>
            {/* YouTube Video Link */}

            {/* About Me */}
            <div className="mb-4">
              <h6 className="fw-bold text-primary d-flex align-items-center">
                ✅ <span className="ms-2">About Me</span>
              </h6>
              <div className="about-me-box p-2 border rounded">
                {profileData.resume_description}
              </div>
            </div>

            {profileData.upload_video && (
              <div className="mb-3 desktop-section candidate-view-desktop-center">
                <h6 className="fw-bold text-primary d-flex align-items-center candidate-view-section-title">
                  <FaGraduationCap size={20} className="me-2" />
                  <span className="ms-2">YouTube Video Link</span>
                </h6>
                <div className="candidate-view-content-wrapper-agency">
                  <div className="badge-pill-container candidate-view-badge-container">
                    <a href={profileData.upload_video} target="_blank" rel="noopener noreferrer">
                      Click here to watch introduction video
                    </a>
                  </div>
                </div>
              </div>
            )}
            {/* Report Link */}
            <div className="text-end">
              <button
                className="text-primary text-decoration-none border-0 bg-transparent"
                onClick={toggleReportForm}
              >
                Report about this post
              </button>
            </div>
          </div>
          {showReportForm && (
            <div className="report-job-section p-3">
              <div className="shadow p-4" style={{ width: '60%', marginLeft: '20%' }}>
                <h5 className="mb-3">Report this job ad</h5>
                <form>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Your email address
                    </label>
                    <input
                      type="email"
                      className="form-control report-job-input"
                      id="email"
                      placeholder="Enter your email"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="reason" className="form-label">
                      Reason for reporting job
                    </label>
                    <select className="form-select report-job-select" id="reason">
                      <option>Please select</option>
                      <option>Fraudulent</option>
                      <option>Misleading</option>
                      <option>Discriminatory</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="details" className="form-label">
                      Please describe your issues with this listing
                    </label>
                    <textarea
                      className="form-control report-job-textarea"
                      id="details"
                      rows="4"
                    ></textarea>
                  </div>
                  <div className="report-job-warning">
                    ⚠️ To help fast track investigation, please include here any other relevant details that prompted you to report this job ad as fraudulent / misleading / discriminatory.
                  </div>
                  {/* Buttons stacked one under the other */}
                  <div className="d-flex flex-column my-5">
                    <button type="submit" className="btn btn-primary report-job-button  mb-3">
                      Report job
                    </button>
                    <button
                      type="button"
                      className="btn btn-link report-job-cancel "
                      onClick={toggleReportForm}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CandidatesViewadmin;

